import { useEffect, useState } from "react";
import { ShieldCheck, RefreshCw } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

const LAB = { probabile: "Verificato", validato: "Validato", parziale: "Da verificare", non_determinabile: "Non determinabile", dati_mancanti: "Dati mancanti" };
const short = (s) => s?.slice(-6);
const pct = (v) => (v == null ? "n.d." : `${Math.round(v * 1000) / 10}%`);

function Relazioni({ list }) {
  const [all, setAll] = useState(false);
  if (!list?.length) return null;
  const vis = all ? list : list.slice(0, 4);
  return (
    <div className="space-y-0.5 text-neutral-400" data-testid="config-relazioni">
      {vis.map((r) => <div key={`${r.a}${r.b}${r.campo}`}>{r.campo === "couple" ? "couple" : "rete"} ·{short(r.a)} ↔ ·{short(r.b)}: <b className="text-neutral-200">{r.interpretazione}</b> · scarto {pct(r.per_spostamento?.["+0 min"]?.diff_mediana)}{r.miglior_spostamento_min ? `, migliore a ${r.miglior_spostamento_min > 0 ? "+" : ""}${r.miglior_spostamento_min} min (${pct(r.per_spostamento?.[`${r.miglior_spostamento_min > 0 ? "+" : ""}${r.miglior_spostamento_min} min`]?.diff_mediana)})` : ", nessun miglioramento spostando"}{r.contatori_diff_mediana != null ? ` · contatori ${pct(r.contatori_diff_mediana)}` : ""}</div>)}
      {list.length > 4 && <button type="button" onClick={() => setAll(!all)} data-testid="config-relazioni-toggle" className="text-neutral-500 underline">{all ? "Mostra meno" : `Mostra tutte (${list.length})`}</button>}
    </div>
  );
}

export function ConfigMisure({ plantId, onChange }) {
  const [c, setC] = useState(null);
  const url = `/monitoring/plants/${encodeURIComponent(plantId)}/configurazione`;
  const load = () => api.get(url).then((r) => setC(r.data)).catch(() => setC(false));
  useEffect(() => { load(); }, [plantId]); // eslint-disable-line react-hooks/exhaustive-deps
  const ricalcola = () => api.post(`${url}/ricalcola`).then(() => toast.success("Analisi avviata: riapri tra un minuto"));
  if (c === null) return null;
  const a = c?.automatico || {};
  const val = c?.validazione && !c.validazione.decaduta;
  return (
    <div className="space-y-2 rounded-xl border border-neutral-800 p-3 text-[11px]" data-testid="config-misure">
      <div className="flex flex-wrap items-center gap-2">
        <ShieldCheck className="h-3.5 w-3.5 text-neutral-400" />
        <b className="uppercase tracking-widest text-neutral-400">Configurazione misure</b>
        <b className="text-white" data-testid="config-stato">{c ? LAB[c.stato] : "non analizzata"}</b>
        {c && val && <span className="text-emerald-400">· confermata da {c.validazione.da}</span>}
        <button type="button" onClick={ricalcola} data-testid="config-ricalcola" className="ml-auto inline-flex items-center gap-1 text-neutral-400 hover:text-white"><RefreshCw className="h-3 w-3" />Ricalcola</button>
      </div>
      {c && <>
        <ul className="list-disc pl-4 text-neutral-300" data-testid="config-motivi">{(a.motivi || []).map((m) => <li key={m}>{m}</li>)}</ul>
        <Relazioni list={[...(a.relazioni_rete || []), ...(a.relazioni_couple || [])].filter((r) => (r.per_spostamento?.["+0 min"]?.diff_mediana ?? 1) < 0.5)} />
        {(a.fonti_ac || []).map((f) => <div key={f.rilevata_su.join()} className="text-amber-400/90" data-testid="config-fonte-ac">Fonte AC: {f.kwh_giorno} kWh/giorno su {f.rilevata_su.length} ibridi · {f.esito === "corrisponde_a_inverter_censito" ? `corrisponde a ·${short(f.inverter_corrispondente)}` : "da identificare, non sommata"}</div>)}
        <div className="text-neutral-500">Periodo {a.periodo?.da} → {a.periodo?.a} · regola {a.regola} · {c.fonte}</div>
      </>}
    </div>
  );
}
